
<img  *ngIf="isFoundCountryInfo" src="/assets/images/flags/4x3/{{countryImage}}.svg" width="26" class="round-image img-flag-span" >
<img  *ngIf="!isFoundCountryInfo" src="/assets/images/icons/htag.svg" width="26" class="round-image img-flag-span" >

